import { render } from "./ManagementControlTable.vue?vue&type=template&id=2238a978&scoped=true&ts=true&lang=pug"
import script from "./ManagementControlTable.vue?vue&type=script&lang=ts"
export * from "./ManagementControlTable.vue?vue&type=script&lang=ts"

import "./ManagementControlTable.vue?vue&type=style&index=0&id=2238a978&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2238a978"]])

export default __exports__